import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 8,
            placeholder: '请选择学院',
            model: "66",
            type: "select",
        },
        {
            label: "点位类别",
            span: 8,
            placeholder: '请选择点位类别',
            model: "77",
            type: "select",
        },
    ]
    const tableColumns = [
        {
            label: "点位名称",
            prop: "name",
            align: "center",
            show: true
        },
        // {
        //     label: "点位类别",
        //     prop: "22",
        //     align: "center",
        //     show:true
        // },
        {
            label: "所属院系",
            prop: "33",
            align: "center",
            show: true
        },
        {
            label: '办理环节',
            prop: "linkNames",
            align: "center",
            width: 300,
            show: true
        },
        {
            label: "联系人",
            prop: "55",
            align: "center",
            show: true,
        },
        {
            label: "联系方式",
            prop: "55",
            align: "center",
            show: true,
        },
        {
            label: "具体位置",
            prop: "address",
            align: "center",
            show: true
        },
        {
            label: "定位",
            name: "custom",
            align: "center",
            width: '120px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "点位类别",
            span: 24,
            placeholder: '请选择点位类别',
            model: "11",
            type: 'select',
            labelClass: 'info-label'
        },
        {
            label: "点位名称",
            span: 24,
            model: "22",
            placeholder: '请输入点位名称',
            labelClass: 'info-label'
        },
        {
            label: "经度",
            span: 12,
            model: "33",
            placeholder: '请输入经度',
        },
        {
            label: "纬度",
            span: 12,
            model: "44",
            placeholder: '请输入纬度',
            // labelWidth:'10px'
        },
        {
            label: "所属院系",
            span: 24,
            model: "55",
            type: 'select',
            placeholder: '请选择所属院系',
            labelClass: 'info-label',
        },
        {
            label: "负责人",
            span: 24,
            model: "66",
            type: 'select',
            placeholder: '请选择负责人',
            labelClass: 'info-label',
        },
        {
            label: "值班人",
            span: 24,
            model: "77",
            type: 'select',
            placeholder: '请选择值班人',
            labelClass: 'info-label',
        },
        {
            label: "选择事项",
            span: 24,
            model: "88",
            type: 'select',
            placeholder: '请选择事项',
            labelClass: 'info-label',
        },
        {
            label: "具体位置",
            span: 24,
            model: "99",
            type: 'textarea',
            placeholder: '请输入具体位置',
            labelClass: 'info-label',
        },
    ]

    const formRules = {
        11: [{
            required: true,
            trigger: "blur",
            message: '请选择点位类别'
        }],
        22: [{
            required: true,
            trigger: "blur",
            message: '请输入点位名称'
        }],
        33: [{
            required: true,
            trigger: "blur",
            message: '请输入经度'
        }],
        44: [{
            required: true,
            trigger: "blur",
            message: '请输入纬度'
        }],
        55: [{
            required: true,
            trigger: "blur",
            message: '请选择所属院系'
        }],
        66: [{
            required: true,
            trigger: "blur",
            message: '请选择负责人'
        }],
        77: [{
            required: true,
            trigger: "blur",
            message: '请选择值班人'
        }],
        88: [{
            required: true,
            trigger: "blur",
            message: '请选择事项'
        }],
    }

    const assistantForm = [
        {
            label: '工号',
            span: 24,
            model: 'teacherId',
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        {
            label: '姓名',
            span: 24,
            model: 'name',
            labelClass: 'info-label',
            labelWidth: '150px',
        },
        // {
        //     label: '证件类型',
        //     span: 24,
        //     model: 'idCardType',
        //     type: 'select',
        //     options: dic._CARDTYPE,
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        // },
        // {
        //     label: '身份证号',
        //     span: 24,
        //     model: 'idCard',
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        //     change(idCardNo) {
        //         // console.log(idCardNo)
        //         if (isIdCardNo(idCardNo)) {
        //             that.handleData.dateBirth = getBirthdayByIdNO(idCardNo)
        //             that.handleData.sex = getSexByIdNO(idCardNo)
        //         } else {
        //             that.handleData.dateBirth = "";
        //             that.handleData.sex = "";
        //         }
        //     }
        // },
        // {
        //     label: '出生日期',
        //     span: 24,
        //     model: 'dateBirth',
        //     // type: 'date',
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        //     disabled: true,
        // },
        // {
        //     label: '性别',
        //     span: 24,
        //     model: 'sexName',
        //     type: 'select',
        //     options: dic._SEXS,
        //     placeholder: "",
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        //     disabled: true,
        // },
        {
            label: '联系电话',
            span: 24,
            model: 'phoneNumber',
            labelClass: 'info-label',
            labelWidth: '150px',
        },

        // {
        //     label: '政治面貌',
        //     span: 24,
        //     model: 'politicalName',
        //     type: 'select',
        //     options: dic._POLITICAL,
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        // },
        // {
        //     label: '婚姻状况',
        //     span: 24,
        //     model: 'marriageStatusName',
        //     type: 'select',
        //     options: dic._HYZK,
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        // },
        // {
        //     label: '民族',
        //     span: 24,
        //     model: 'nationName',
        //     type: 'select',
        //     options: dic._NATION,
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        // },
        // {
        //     label: '详细住址',
        //     span: 24,
        //     model: 'addressInfo',
        //     labelClass: 'info-label',
        //     labelWidth: '150px',
        // }
    ]
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules,
        assistantForm
    }
}
